export const FoodObjects = [
  {
    header: "Kubideh",
    info: "Zwei Hackfleischspieße aus Lammfilet serviert mit Butter, Reis und Grilltomate",
  },
  {
    header: "Barg",
    info: "Ein Spieß aus Lammfilet serviert mit Butter, Reis und Grilltomate",
  },
  {
    header: "Chenjeh Soltani",
    info: "Ein Spieß aus Lammfilet und ein Hackfleischspieß serviert mit Butter, Reis und Grilltomate",
  },
  {
    header: "Tschendje",
    info: "Ein Spieß aus Lammfilet serviert mit Butter, Reis und Grilltomate",
  },
  {
    header: "Schapuri",
    info: "Ein Spieß Hähnchenbrustfilet und ein Hackfleischspieß aus Lammfilet serviert mit Butter, Reis und Grilltomate",
  },
  {
    header: "Soltani",
    info: "Ein Spieß aus Lammfilet und ein Hackfleischspieß serviert mit Butter, Reis und Grilltomate",
  },
  {
    header: "Djujeh Kabab (Filet)",
    info: "Ein Spieß Hähnchenbrustfilet mariniert serviert mit Butter, Reis und Grilltomate",
  },
  {
    header: "Djujeh Kabab (mit Knochen)",
    info: "Ein Spieß Hähnchen mit Knochen serviert mit Butter, Reis und Grilltomate",
  },
  {
    header: "Ghormessabsi",
    info: "Sauce aus verschiedenen Kräuter, getrocknete Limetten, Rote Bohnen und Lammgulasch mit Reis",
  },
  {
    header: "Khoresht Ghejmeh",
    info: "Sauce aus Linsen, fr. Tomaten, getrocknete Limetten und Lammgulasch mit Reis",
  },
  {
    header: "Khoresht Ghejmeh Bademjan",
    info: "Sauce aus Linsen, fr. Tomaten, getrocknete Limetten, gebratener Aubergine und Lammgulasch mit Reis",
  },
  {
    header: "Khoresht Karafs",
    info: "Sauce aus Sellerien, Petersillien, Minze und Lammgulasch mit Reis",
  },
  {
    header: "Khoresht Fessendschan",
    info: "Sauce aus gemahlenen Wallnüssen, Granatapfel Mark, Reis und Hähnchenfleisch",
  },
  {
    header: "Baghali Polo ba Mahicheh",
    info: "Gekochte Lamm Haxe in einer Spezialsauce serviert mit Reis, dicken Bohnen und Dill",
  },
  {
    header: "Mirza Ghassemi",
    info: "Gegrillte Auberjine mit Knoblauch, frischen Tomaten, Ei und Tomatenmark",
  },
  {
    header: "Kashk-e Bademjan",
    info: "Gebratene Auberjine serviert mit Molke und geräucherte Zwiebeln",
  },
]
